import { Icon } from "armstrong-react";
import classNames from "classnames";
import React from "react";
import { Link } from "react-router";
import "./navMenu.scss";

/**
 * @param {string} label - Label to be shown within the link.
 * @param {string} id - A DOM ID reference relating to this navigation item (NOT A postgres table ID).
 * @param {string} slug - Slug to be used as the element ID, for URL hash anchor linking;
 * @param {string} relatedPage - Used for sub pages;
 */
export interface NavMenuItem {
  label: string;
  id: string;
  slug: string;
  relatedPage?: string;
}

interface Props {
  label?: string;
  items: NavMenuItem[];
  selectOnMobile?: boolean;
  activeItem: string;
  baseRoute?: string;

  onItemClick?(id: string): any;
  onSelectChange?(id: string): any;
}

export class NavMenu extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  private updateHashMobile = (event: React.ChangeEvent<any>) => {
    const slug: string = this.props.items.find(item => item.id === event.target.value).slug;
    history.replaceState(null, null, `#${slug}`);
    this.props.onSelectChange(event.target.value);
  }

  private updateHash = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, itemId: string) => {
    const { onItemClick } = this.props;
    e.preventDefault(); // Native route change affects zenscroll.to method
    const slug: string = this.props.items.find(item => item.id === itemId).slug;
    history.replaceState(null, null, `#${slug}`);
    onItemClick(itemId);
  }

  private renderLink = (item: NavMenuItem): JSX.Element => {
    const { baseRoute, onItemClick, activeItem } = this.props;
    const itemClassName = classNames("nav-menu__item-button", { "nav-menu__item-button--active": item.id === activeItem });

    if (!onItemClick && baseRoute && baseRoute.length > 0) {
      return (
        <Link className={itemClassName} to={`${baseRoute}#${item.slug}`}>{item.label}</Link>
      );
    }
    if (!onItemClick && !baseRoute) {
      return (
        <a className={itemClassName} href={`#${item.slug}`}>{item.label}</a>
      );
    }
    if (onItemClick) {
      return (
        <a className={itemClassName} onClick={(e) => this.updateHash(e, item.id)} href={`#${item.slug}`}>{item.label}</a>
      );
    }
    return null;
  }
  public render() {
    const { label, items, selectOnMobile, activeItem } = this.props;

    return (
      <div className="nav-menu">
        {label && (
          <div className="nav-menu__header">
            <span className="heading--5">{label}</span>
          </div>
        )}

        <nav className={selectOnMobile ? "hide-on-mobile" : ""}>
          <ul>
            {items.map(item => (
              <li className={classNames("nav-menu__li", { "nav-menu__li--active": item.id === activeItem })} key={item.id}>
                {this.renderLink(item)}
              </li>
            ))}
          </ul>
        </nav>

        {(selectOnMobile) && (
          <div className="nav-menu__select-wrapper">
            <select onChange={this.updateHashMobile} value={activeItem}>
              {items.map(item => (
                <option value={item.id} key={item.id}>{item.label}</option>
              ))}
            </select>
            <Icon icon={Icon.Icomoon.arrowDown3} />
          </div>
        )}
      </div>
    );
  }
}
